/**
 * Labstep
 *
 * @module grid/NewIndex/coldefs/experiment-workflow/tags
 * @desc Column Definition for experiment workflow tags
 */

import type {
  EditableCallbackParams,
  ValueGetterParams,
} from 'ag-grid-community';
import TagManager from 'labstep-web/components/Tag/Manager';
import { ICONS } from 'labstep-web/constants/icons';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import type {
  CellEditorParams,
  CellRendererParams,
} from 'labstep-web/core/DataGrid/types';
import { stopEditingAndFocus } from 'labstep-web/core/DataGrid/utils';
import { GridNewIndexService } from 'labstep-web/grid/NewIndex/services/grid-new-index.service';
import type { Entity } from 'labstep-web/models/entity.model';
import type { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type { Tag } from 'labstep-web/models/tag.model';
import { Label } from 'semantic-ui-react';

export const colDefExperimentWorkflowTags = {
  colId: 'tags',
  headerName: 'Tags',
  headerComponentParams: {
    icon: ICONS.tag.primary,
    postFilterSettings: {
      field: 'tags',
      disableSort: true,
    },
  },
  editable: (params: EditableCallbackParams) => {
    return GridNewIndexService.getEditable(params);
  },
  autoHeight: true,
  valueGetter: (params: ValueGetterParams): string | null =>
    params.data?.tags?.map((tag: Tag) => tag.name).join(',') || null,
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data?.tags?.map((tag: Tag) => tag.name).join(',') ||
    '',
  cellRenderer: (params: CellRendererParams<Entity>) => {
    return params.node?.data?.tags_preview?.map((tag: Tag) => (
      <Label key={tag.id}>{tag.display_name}</Label>
    ));
  },
  cellEditor: (params: CellEditorParams<ExperimentWorkflow>) => {
    const { data } = params;
    return (
      <ParamsStateContextProvider value={{}}>
        <TagManager
          parentEntity={data}
          open
          onClose={(): void => stopEditingAndFocus(params)}
        />
      </ParamsStateContextProvider>
    );
  },
};
